import { render, staticRenderFns } from "./SpHeader.vue?vue&type=template&id=10c5c252&scoped=true&"
import script from "./SpHeader.vue?vue&type=script&lang=ts&"
export * from "./SpHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SpHeader.vue?vue&type=style&index=0&id=10c5c252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5c252",
  null
  
)

export default component.exports